// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yVNm00xuxrfiOmOONgSs {
  height: auto;
  display: flex;
  background-color: var(--md-grey-color);
  flex-direction: column;
  overflow: hidden;
}

.IiRgdErJoB0Vx9uICHG3 {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-color);
  background-color: var(--place-color);

  flex-direction: column;
}

.IiRgdErJoB0Vx9uICHG3 h1 {
  font-size: var(--step-3);
}

.W76fHFQpSjM_mqEoVUs6 {
  width: 80%;
}

.W76fHFQpSjM_mqEoVUs6 p {
  max-width: 100%;
  font-size: var(--step-1);
  line-height: var(--base-line-height);
}

.TBEW5WTcCLfNKC7PwWSa {
  color: var(--white-color);
}

._dxsgNG72Sap_jUY9D47 {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.VeiIhwoZ3A645fnHUFzb {
  display: flex;
  flex-direction: column;

  border-radius: 10px;
}

.SWJOXGHOW8pLOBdN7y0K {
  margin-bottom: 1rem;
  width: 100%;
}

.aMGK42ct3at9X7I8cW8b {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  gap: var(--space-xs);
}

.ZSBNmYKLoWr2i7v4ri9A {
  background-color: var(--primary-color);
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Fac16vIkUeE4nrW1a5Ng {
  width: 100%;
  background-color: var(--dk-grey-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Fac16vIkUeE4nrW1a5Ng h2 {
  font-size: var(--step-0);
}

.TzxN36RrLgjabRH6Du76 {
  width: 90%;
  padding-block: 1rem;
}

@media screen and (min-width: 1024px) {
  .IiRgdErJoB0Vx9uICHG3 {
    flex-direction: row;
    padding-bottom: 0rem;
  }

  .Fac16vIkUeE4nrW1a5Ng {
    display: flex;
    flex-direction: column;
    background-color: var(--dk-grey-color);

    width: 50%;
    justify-content: center;
    align-items: center;
  }

  .TzxN36RrLgjabRH6Du76 {
    width: 95%;
  }

  .W76fHFQpSjM_mqEoVUs6 {
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: center;
    padding-left: 3rem;
  }

  .W76fHFQpSjM_mqEoVUs6 p {
    max-width: 70%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AllPlacesPage/AllPlacesPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;;EAEpC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;;EAEf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,sCAAsC;;IAEtC,UAAU;IACV,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".allPlacesPage {\n  height: auto;\n  display: flex;\n  background-color: var(--md-grey-color);\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.aboutSection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white-color);\n  background-color: var(--place-color);\n\n  flex-direction: column;\n}\n\n.aboutSection h1 {\n  font-size: var(--step-3);\n}\n\n.topAbout {\n  width: 80%;\n}\n\n.topAbout p {\n  max-width: 100%;\n  font-size: var(--step-1);\n  line-height: var(--base-line-height);\n}\n\n.pillLinkSection {\n  color: var(--white-color);\n}\n\n.stateGroupWrapper {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.stateGroup {\n  display: flex;\n  flex-direction: column;\n\n  border-radius: 10px;\n}\n\n.stateHeader {\n  margin-bottom: 1rem;\n  width: 100%;\n}\n\n.citiesContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  gap: var(--space-xs);\n}\n\n.pillSearchBar {\n  background-color: var(--primary-color);\n  height: 5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.map {\n  width: 100%;\n  background-color: var(--dk-grey-color);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.map h2 {\n  font-size: var(--step-0);\n}\n\n.mapWrapper {\n  width: 90%;\n  padding-block: 1rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .aboutSection {\n    flex-direction: row;\n    padding-bottom: 0rem;\n  }\n\n  .map {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--dk-grey-color);\n\n    width: 50%;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .mapWrapper {\n    width: 95%;\n  }\n\n  .topAbout {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    justify-content: center;\n    padding-left: 3rem;\n  }\n\n  .topAbout p {\n    max-width: 70%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allPlacesPage": `yVNm00xuxrfiOmOONgSs`,
	"aboutSection": `IiRgdErJoB0Vx9uICHG3`,
	"topAbout": `W76fHFQpSjM_mqEoVUs6`,
	"pillLinkSection": `TBEW5WTcCLfNKC7PwWSa`,
	"stateGroupWrapper": `_dxsgNG72Sap_jUY9D47`,
	"stateGroup": `VeiIhwoZ3A645fnHUFzb`,
	"stateHeader": `SWJOXGHOW8pLOBdN7y0K`,
	"citiesContainer": `aMGK42ct3at9X7I8cW8b`,
	"pillSearchBar": `ZSBNmYKLoWr2i7v4ri9A`,
	"map": `Fac16vIkUeE4nrW1a5Ng`,
	"mapWrapper": `TzxN36RrLgjabRH6Du76`
};
export default ___CSS_LOADER_EXPORT___;
